<template>
  <div class="main-body">
    <div class="header">改造项目</div>
    <div class="out">

      <div class="search2">
        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float:right">

          <el-select v-model="bedGoodsClassCode" clearable placeholder="请选项目分类" title="项目分类"
                     style="width:200px;margin-right:10px">
            <el-option
                v-for="item in bedGoodsClassList"
                :key="item.bedGoodsClassCode"
                :label="item.name"
                :value="item.bedGoodsClassCode">
            </el-option>
          </el-select>

          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>
        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>


        <el-table-column prop="bedGoodsClassName" label="项目分类" ></el-table-column>

        <el-table-column prop="name" label="改造项目" ></el-table-column>

        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="150">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";

import {timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data(){
    return{

      tableData:[],
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      bedGoodsClassList:[],
      bedGoodsClassCode:'',

      showModalAdd:false,
      showModalEdit:false,

      th:0,

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;

    this.getClassList();

  },
  components:{
    Add,Edit
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },


    search(){
      this.currentPage = 1;
      this.getList();
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },
    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BedGoods/InsPage',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          bedGoodsClassCode:this.bedGoodsClassCode,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },



    getClassList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'BedGoodsClass/List',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.bedGoodsClassList = response.data.data;
          if(this.bedGoodsClassList.length>0){
            //this.activityClassCode = this.activityClassList[0].activityClassCode;
          }

        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },


  }
}
</script>

<style scoped>

</style>
